<template>
  <div class="home">


    <div class="creppy-white-blass-wait">
      <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">Team</h5>

      <br class="no-move"/>

    </div>

    <div class="main-title">

      <br class="no-move"/>

      <h1 class="headers-text text-dark"><strong>Unser Foto</strong></h1>

      <br class="no-move"/>

      <b-img src="../assets/teamBild.jpg" class="img-big no-move"></b-img>
      <p class="footnote-text text-white-gray-color">Stand 18.04.2021</p>

      <br class="no-move"/>

      <div class="container">

        <h1 class="headers-text text-dark"><strong>Mehr von uns...</strong></h1>
        <p class="body-title-lighter text-dark"><strong>Eine genauere Auflistung der Team Mitglieder findest du<br/> mit dem LabyHelp Befehl <i>"/lhteam"</i>!</strong></p>

      </div>

      <br class="no-move"/>

      <div class="" style="alignment: bottom">

        <div class="" style="alignment: bottom">
          <p class="smaller-end-text">© {{today.getFullYear()}}
            <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
            <a style="color: #6868b3"
               href="https://labyhelp.de/support">Support</a>
            -
            <a style="color: #6868b3"
               href="https://labyhelp.de/apply">Apply</a>
            -
            <a style="color: #6868b3"
               href="https://labyhelp.de/creator">Creator</a>
            -
            <a style="color: #6868b3"
               href="ts3server://labyhelp.de">TeamSpeak</a>
          </p>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Team",
  data() {
    return {
      today: new Date()
    }
  },
}
</script>

<style scoped>

</style>